//Use to capitalize the first letter

export const capitalizeCityName = (cityName) => {
  if (!cityName) return "";
  return cityName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
